import { classes } from "portal/theme/theme";
import { Paper } from "@mui/material";
import React, {
  ComponentPropsWithoutRef,
  ElementType,
  FunctionComponent,
  PropsWithChildren,
  ReactElement,
} from "react";

// Typography shared by the metric rows and row-level headers inside the
// certified metric sections (the design calls for 14px text on a 16px line,
// medium weight; no MUI typography variant matches).
const METRIC_ROW_CLASSES =
  "flex flex-wrap justify-between items-center text-sm leading-4 font-medium";

// A label/value row (or row-level header) inside a certified metric section.
// Renders a div by default; pass `component` (e.g. Typography) to render
// something else. All other props pass through to the rendered element.
export const MetricRow = <C extends ElementType = "div">({
  component,
  className,
  ...props
}: {
  component?: C;
  className?: string;
} & Omit<
  ComponentPropsWithoutRef<C>,
  "component" | "className"
>): ReactElement => {
  const Component: ElementType = component ?? "div";
  return (
    <Component className={classes(METRIC_ROW_CLASSES, className)} {...props} />
  );
};

export const MetricSubsection: FunctionComponent<PropsWithChildren> = ({
  children,
}) => {
  return <Paper className="p-4 pe-3 flex flex-col gap-1">{children}</Paper>;
};
